import { rem } from "@certn/cascadia";
import { List, ListItem } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

export const useLearnMoreModalContents = () => {
  const { t } = useTranslation();
  const learnModalModalList = [
    t("Employer income (average monthly, estimated net annual, frequency)"),
    t("Non-employer income"),
    t("Other income"),
    t(
      "Account details (account age, activity trend, monthly cash flow, recurring deposits, recurring payments)"
    ),
    t(
      "Transaction insights (balance trend, current balance, number of days with negative balance)"
    ),
  ];

  return (
    <>
      <div className={styles.paddingBottom}>
        <Trans>
          Certn has partnered with Flinks to securely verify income directly
          with your bank. Information we may collect and share in the report may
          include:
        </Trans>
      </div>
      <List type="unordered" size="primary">
        {learnModalModalList.map((item, i) => {
          return <ListItem key={i}>{item}</ListItem>;
        })}
      </List>
    </>
  );
};

const styles = {
  paddingBottom: css({
    paddingBottom: rem("space-4"),
  }),
};
